export default __webpack_public_path__ + "static/media/lock.c1396030.jpg";